import angular from '../assets/languages/angular.svg'
import typescript from '../assets/languages/typescript.svg'
import android from '../assets/languages/android.svg'
import next from '../assets/languages/next.svg'
import jquery from '../assets/languages/jquery.svg'
import js from '../assets/languages/js.svg'
import nodejs from '../assets/languages/node.svg'
import html from '../assets/languages/html.svg'
import vuejs from '../assets/languages/vuejs.svg'
import react from '../assets/languages/react.svg'

import Consulting from '../assets/SERVICES/Consulting.svg'
import DigitalMarketing from '../assets/SERVICES/digitalMarketing.svg'
import ITconsultancy from '../assets/SERVICES/ITconsultancy.svg'
import Technical from '../assets/SERVICES/Technical.svg'
import WebDesign from '../assets/SERVICES/WebDesign.svg'
import WebDevelopment from '../assets/SERVICES/WebDevlopment.svg'

import education from '../assets/solutions/education.svg'
import finance from '../assets/solutions/finance.svg'
import healthcare from '../assets/solutions/healthcare.svg'
import retail from '../assets/solutions/retail.svg'
import travel from '../assets/solutions/travel.svg'






  export const titles = [
    { id: 1, title: "At Omniebee Global Solutions we Create, Innovate, and Customize a standout website tailored for your brand." },
    { id: 2, title: "Premium technical solutions crafted to elevate your business." },
    { id: 3, title: "Expert consultancy to strengthen customer loyalty and enhance user experience." },
    { id: 4, title: "A 5% improvement in retention can boost profitability by up to 25%." },
];


export const images = [
    { id: 1, src: angular, alt: "Angular Framework" },
    { id: 2, src: next, alt: "Next Js" },
    { id: 3, src: react, alt: "ReactJS Development" },
    { id: 4, src: vuejs, alt: "Vue Js" },
    { id: 5, src: js, alt: "Javascript" },
    { id: 6, src: nodejs, alt: "Node.js Services" },
    { id: 7, src: typescript, alt: "Typescript" },
    { id: 8, src: jquery, alt: "jQuery Libraries" },
    { id: 9, src: html, alt: "HTML" },
    { id: 10, src: android, alt: "iOS & Android Apps" },
];

export const solutions = [
    { id: 1, description: "Empowering the healthcare sector with scalable and innovative digital tools.", src: healthcare, title: "Healthcare" },
    { id: 2, description: "Providing comprehensive tech support to finance and banking industries.", src: finance, title: "Banking & Finance" },
    { id: 3, description: "Tailoring e-commerce platforms to meet the dynamic demands of online retail.", src: retail, title: "Retail & E-commerce" },
    { id: 4, description: "Transforming education with cutting-edge digital learning solutions.", src: education, title: "E-learning & Education" },
    { id: 5, description: "Enhancing travel and tourism through innovative digital integrations.", src: travel, title: "Travel & Tourism" },
];


export const services = [
  { 
      id: 1, 
      title: "Website Design", 
      description: [
          "Crafting visually stunning  websites to amplify your presence.",
          "Utilizing the latest design trends to create responsive layouts.",
          "Implementing SEO best practices to enhance visibility.",
          "Ensuring cross-browser compatibility for a seamless user experience."
      ], 
      src: WebDesign 
  },
  { 
      id: 2, 
      title: "Mobile App Development", 
      description: [
          "Delivering seamless and secure app experiences designed to captivate users.",
          "Building native and cross-platform applications for wider reach.",
          "Integrating advanced features like push notifications and in-app purchases.",
          "Conducting thorough testing to ensure performance and reliability."
      ], 
      src: WebDevelopment 
  },
  { 
      id: 3, 
      title: "Consultancy Solutions", 
      description: [
          "Strategic IT guidance to align technology with your business goals.",
          "Assessing current IT infrastructure for optimization opportunities.",
          "Providing tailored recommendations for technology investments.",
          "Supporting implementation and change management processes."
      ], 
      src: ITconsultancy 
  },
  { 
      id: 4, 
      title: "Digital Campaigns", 
      description: [
          "Innovative marketing strategies to drive impactful digital transformations.",
          "Leveraging data analytics to target the right audience effectively.",
          "Creating engaging content that resonates with users.",
          "Monitoring and optimizing campaigns for maximum ROI."
      ], 
      src: DigitalMarketing 
  },
  { 
      id: 5, 
      title: "Tech Support", 
      description: [
          "Reliable technical assistance to ensure uninterrupted operations.",
          "Providing 24/7 support for immediate issue resolution.",
          "Offering remote and on-site assistance based on client needs.",
          "Implementing proactive maintenance to prevent future issues."
      ], 
      src: Technical 
  },
  { 
      id: 6, 
      title: "Business Consulting", 
      description: [
          "Custom strategies to enhance processes and secure your data systems.",
          "Conducting comprehensive assessments to identify areas for improvement.",
          "Developing actionable plans to achieve operational efficiency.",
          "Facilitating workshops and training sessions for staff development."
      ], 
      src: Consulting 
  },
];





export const ServicesDetails = [
    {
        id: 0,
        titleTwo: "Why Opt for Our Web Design Services at Omniebee Global Solutions",
        titleOne: "WEB DESIGN",
        description: "We create modern, user-friendly, and optimized websites that drive results and are easy to maintain.",
        descriptionTwo: [
            "Achieve the perfect balance of quality and cost with our web design solutions.",
            "We make sure your site performs flawlessly across all mobile devices.",
            "Collaborating closely with you, we refine designs based on feedback.",
            "Our strategies are tailored to boost your website's effectiveness.",
            "We bring expertise in various frameworks and tools to deliver top-notch designs.",
            "Our team excels in both graphic and traditional design aesthetics.",
            "Responsive design ensures seamless experiences on any device.",
            "Our pricing is transparent, with no hidden charges.",
            "We take the time to deeply understand your brand and vision."
        ],
        descriptionOne: [
            "Our focus is on building tailored websites that represent your brand and meet your business goals.",
            "We specialize in responsive designs that adapt to various screen sizes and platforms.",
            "From CMS integrations to search engine optimization, we prioritize functionality and visibility.",
            "Our team delivers distinctive and impactful designs to make your brand stand out.",
            "We combine strong visuals with a user-first approach to enhance your online presence."
        ]
    },
    {
        id: 1,
        titleTwo: "Why Choose Our Web Development Solutions",
        titleOne: "WEB DEVELOPMENT",
        description: "We deliver secure and intuitive app development services, protecting your data and engaging users.",
        descriptionTwo: [
            "We focus on creating solutions that align with your business needs and audience expectations.",
            "Our process involves you at every step, ensuring your feedback shapes the final product.",
            "Our team offers comprehensive web and app development at competitive prices.",
            "With experience across industries, we understand diverse business needs.",
            "We provide scalable, user-friendly, and manageable development solutions.",
            "Our services extend beyond coding, focusing on seamless user experiences."
        ],
        descriptionOne: [
            "We craft high-quality websites that reflect your brand and resonate with your audience.",
            "Our designs ensure optimal user experience, whether on mobile or desktop.",
            "Our experts bring a mix of creativity and technical expertise to every project.",
            "We address your unique business challenges with custom-built solutions.",
            "By integrating design and development, we provide cohesive and impactful websites."
        ]
    },
    {
        id: 2,
        titleTwo: "Benefits of Our Digital Marketing Expertise",
        titleOne: "DIGITAL MARKETING",
        description: "Our data-driven marketing strategies deliver measurable results across multiple platforms.",
        descriptionTwo: [
            "We ensure a flawless user experience across devices and platforms.",
            "We rejuvenate outdated websites with fresh and modern designs.",
            "Our strategies keep your audience connected to the latest digital trends.",
            "Real-time analytics and insights inform our best practices.",
            "We secure your data and create cohesive marketing designs.",
            "Our adaptive marketing tools help your business stay relevant in an evolving digital landscape.",
            "We focus on creating solutions that grow with your business needs.",
            "From planning to execution, our campaigns deliver impactful results."
        ],
        descriptionOne: [
            "We work with you to increase visibility, traffic, and conversions for your business.",
            "Our campaigns are tailored to your goals, ensuring a high return on investment.",
            "We bring a collaborative approach to every project, treating your business as our own.",
            "Our marketing strategies are built on in-depth market research and analysis.",
            "We leverage innovative tools and industry expertise to maximize campaign success."
        ]
    },
    {
        id: 3,
        titleTwo: "Why Trust Us for Technical Support",
        titleOne: "TECHNICAL SUPPORT",
        description: "We provide dependable solutions to address technical challenges and enhance performance.",
        descriptionTwo: [
            "We analyze your needs to determine the most suitable technology stack.",
            "Our experts simplify complex processes and offer comprehensive support.",
            "Each solution is customized to meet the unique requirements of your business.",
            "We create proof-of-concepts to evaluate feasibility and long-term impact.",
            "Our systems are automated for seamless deployment and maintenance.",
            "We employ cutting-edge tools to deliver reliable technical solutions."
        ],
        descriptionOne: [
            "We enable businesses to embrace new technologies and adapt to modern challenges.",
            "Our team ensures smooth operations by resolving issues promptly.",
            "Real-time collaboration with our clients ensures every project runs efficiently.",
            "From mobile applications to cloud solutions, we enhance digital transformation.",
            "Custom software development enables businesses to innovate and thrive in their industries."
        ]
    },
    {
        id: 4,
        titleTwo: "Why Choose Our Expert Consultancy Services",
        titleOne: "CONSULTANCY",
        description: "We provide actionable strategies and expert advice to drive business success.",
        descriptionTwo: [
            "Our consultancy services automate and streamline business processes.",
            "We facilitate effective collaboration and innovation within your team.",
            "Our solutions enable you to store and analyze large amounts of data securely.",
            "We help businesses explore new opportunities and address potential challenges.",
            "Our partnerships with industry experts ensure top-tier advice and support.",
            "We provide end-to-end services, including IT, marketing, and web solutions."
        ],
        descriptionOne: [
            "We collaborate with businesses to design innovative strategies for growth.",
            "Our experience spans industries, offering solutions tailored to diverse needs.",
            "From cloud computing to e-learning, we help organizations achieve their goals.",
            "Our team provides the tools and insights needed to stay ahead in a competitive market.",
            "By integrating advanced technologies, we enhance efficiency and profitability."
        ]
    }
];


export const expertiseDetails = [
    {
      id: 0,
      title: "MEAN Stack",
      descriptions: [
        "Omniebee Global Solutions Mean Stack developers are skilled in different platforms.",
        "Omniebee Global Solutions developers wide experience with MEAN Stack development services lets us quickly craft tailored solutions for large and mid-level enterprises.",
        " Omniebee Global Solutions can build high-performing, accessible, and secure web and mobile applications with our expertise as a MEAN Stack development company.",
        "Omniebee Global Solutions extensive experience with MEAN Stack development services helps us build intuitive and effective content management systems for your business.",
        "We have years of domain expertise in business platforms and applications using MEAN Stack-based frameworks while retaining its full feature set."
      ]
    },
    {
      id: 1,
      title: "Node.js",
      descriptions: [
        "Node.js deals with API or real-time web programming, allowing the creation of sophisticated web applications.",
        "Node.js apps can handle a significant amount of traffic and are highly scalable.",
        "Our team of skilled designers provides creative and visually appealing web and mobile app UI/UX development services following the latest design trends.",
        "ResourceOne offers high-performing and scalable enterprise-oriented API development services tailored to your business needs.",
        "We assist with migrating your website to Node.js or updating its current version.",
        "ResourceOne provides round-the-clock Node.js support and maintenance services for our valued customers."
      ]
      
    },
    {
      id: 2,
      title: "React Native",
      descriptions: [
        "If you want to migrate your app to the React Native platform or update its current version, we are always ready to assist you.",
        "We provide high-performing and accessible enterprise-oriented React Native app solutions tailored to your specific business needs.",
        "Our expertise extends to offering round-the-clock React Native app development support and maintenance services.",
        "From the initial stages, our quality analysts ensure your app runs seamlessly across all browsers and screens.",
        "ResourceOne delivers end-to-end React Native solutions, including prototyping, UI/UX design, development, and deployment."
      ]
    },
    {
      id: 3,
      title: "Angular.JS",
      descriptions: [
        "Choose Angular.JS development services from ResourceOne to build reliable, scalable, and dynamic applications.",
        "We offer high-performing and scalable enterprise-oriented API development services tailored to your business needs.",
        "Our AngularJS developers provide round-the-clock support and maintenance services for our esteemed clients.",
        "Angular.JS development services are cost-effective, minimize development time, and offer mobile-friendly solutions.",
        "Our result-driven software development services help increase ROI and efficiently manage daily workflows."
      ]
    },
    {
      id: 4,
      title: "React.JS",
      descriptions: [
        "ResourceOne is trusted for React.JS development expertise, offering web app solutions tailored to your business needs.",
        "We provide responsive web applications with tailored themes, feature-rich plugins, and mobile-friendly interfaces.",
        "Our team ensures perfect code quality, responsive and user-friendly design, and an upgraded navigation system.",
        "We prioritize scalability and security with advanced measures like high-security plugins, data encryption, and secure admin dashboards.",
        "With years of experience, ResourceOne has satisfied numerous clients by understanding React.JS intricacies and fulfilling client needs with excellence."
      ]
    },
    {
      id: 5,
      title: "Vue.JS",
      descriptions: [
        "Vue.JS is our preferred development framework, ensuring fast response times and improved performance.",
        "Our experienced developers are proficient in third-party integrations using Vue.JS.",
        "ResourceOne offers comprehensive Vue.JS services, including consultation, planning, and final web app development.",
        "We provide full support and maintenance for Vue.JS web applications to ensure ongoing customer satisfaction.",
        "We guarantee timely delivery of results, meeting or exceeding expectations.",
        "Each project is overseen by a technical lead, ensuring the team’s expertise aligns with project requirements."
      ]
    },
    {
      id: 6,
      title: "Android",
      descriptions:  [
        "ResourceOne excels in providing secure, accessible, and high-performing Android applications.",
        "We design enterprise-oriented Android app solutions tailored to meet specific business needs.",
        "Our apps ensure maximum scalability and security using advanced encryption and secure admin dashboards.",
        "ResourceOne delivers end-to-end Android app development, from UI/UX design to deployment in app stores.",
        "We offer flexible engagement models to address varied business requirements within specified timelines."
      ]
      
    },
    {
      id: 7,
      title: "iOS",
      descriptions: [
        "ResourceOne offers a wide range of iOS application development services, including full-stack development, migration, and business-oriented solutions.",
        "Our expertise ensures the delivery of top-notch iOS app development tailored to meet client needs.",
        "Our iOS developers implement the latest UI/UX design trends for attractive and user-friendly applications.",
        "We recommend the best engagement model, timelines, and budget based on project requirements.",
        "Our developed iOS applications provide lightning-fast user experiences, loading within just five seconds."
      ]
    }
  ];
  